// src/pages/LoginPage.tsx
import React, { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api'; // ensure this is your configured Axios instance

export default function LoginPage() {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCredentials(c => ({ ...c, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await api.post('/auth/login', credentials);
      localStorage.setItem('token', res.data.token); // adjust depending on your API
      navigate('/customers');
    } catch (error) {
      alert("Login failed");
      console.error(error);
    }
  };

  // useEffect(() => {
  //   const token = localStorage.getItem('token');
  //   if (token) {
  //     navigate('/customers');
  //   }
  // }, []);
  

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <Paper sx={{ p: 4, width: 400 }} component="form" onSubmit={handleSubmit}>
        <Typography variant="h5" mb={2}>התחברות</Typography>
        <TextField
          label="שם משתמש"
          name="username"
          value={credentials.username}
          onChange={handleChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="סיסמה"
          name="password"
          type="password"
          value={credentials.password}
          onChange={handleChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
        >
          התחבר
        </Button>
      </Paper>
    </Box>
  );
}
